import { Sprite } from 'pixi.js';

export class TileGoldIdle extends Sprite {
    constructor(size: [number, number]) {
        super();

        const assets = PIXI.utils.TextureCache;
        const frames = [
            assets['fx/tile-gold-idle0001'],
            assets['fx/tile-gold-idle0002'],
            assets['fx/tile-gold-idle0003'],
            assets['fx/tile-gold-idle0004'],
            assets['fx/tile-gold-idle0005'],
            assets['fx/tile-gold-idle0006'],
            assets['fx/tile-gold-idle0007'],
            assets['fx/tile-gold-idle0008'],
            assets['fx/tile-gold-idle0009'],
            assets['fx/tile-gold-idle0010'],
            assets['fx/tile-gold-idle0011'],
            assets['fx/tile-gold-idle0012'],
            assets['fx/tile-gold-idle0013'],
            assets['fx/tile-gold-idle0014'],
            assets['fx/tile-gold-idle0015'],
            assets['fx/tile-gold-idle0016'],
            assets['fx/tile-gold-idle0017'],
            assets['fx/tile-gold-idle0018'],
            assets['fx/tile-gold-idle0019'],
            assets['fx/tile-gold-idle0020'],
            assets['fx/tile-gold-idle0021'],
            assets['fx/tile-gold-idle0022'],
            assets['fx/tile-gold-idle0023'],
            assets['fx/tile-gold-idle0024'],
            assets['fx/tile-gold-idle0025'],
            assets['fx/tile-gold-idle0026'],
            assets['fx/tile-gold-idle0027'],
        ];

        const anim = new PIXI.extras.AnimatedSprite(frames);
        anim.anchor.set(0.5);
        anim.animationSpeed = 0.5;
        anim.loop = false;

        this.addChild(anim);
        anim.play();

        anim.onComplete = () => {
            setTimeout(() => {
                if (this.parent) {
                    anim.gotoAndPlay(1);
                } else {
                    anim.destroy();
                    this.destroy();
                }
            }, 1000);
        };
    }
}
